import { render, staticRenderFns } from "./CardSkeleton.vue?vue&type=template&id=2c3cda1c&scoped=true&"
import script from "./CardSkeleton.vue?vue&type=script&lang=ts&"
export * from "./CardSkeleton.vue?vue&type=script&lang=ts&"
import style0 from "./CardSkeleton.vue?vue&type=style&index=0&id=2c3cda1c&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3cda1c",
  null
  
)

export default component.exports